module.exports = __webpack_public_path__ + "static/img/skill-lol.71d5e43a.png";